export const DIALOG_SIZE = {
  xs: {
    width: '30vw',
    minHeight: '15vh',
    maxHeight: '50vh',
  },
  sm: {
    width: '30vw',
    minHeight: '30vh',
    maxHeight: '80vh',
  },
  md: {
    width: '50vw',
    minHeight: '50vh',
    maxHeight: '65vh',
  },
  lg: {
    width: '70vw',
    minHeight: '70vh',
    maxHeight: '80vh',
  },
  xl: {
    width: '95vw',
    minHeight: '95vh',
    maxHeight: '95vh',
  },
  full: {
    width: '100vw',
    minHeight: '100vh',
    maxHeight: '100vh',
  },
};

/** Minimum width (vw) for md-tier dialogs — used to decide fullscreen eligibility. */
export const DIALOG_MD_MIN_WIDTH_VW = 50;

/**
 * Returns true when the dialog width is at md tier or larger (>= 50vw).
 * Pixel widths are compared against the current viewport.
 */
export function isMdOrLargerDialogWidth(width?: string): boolean {
  if (!width) {
    return false;
  }
  const vwMatch = /^([\d.]+)vw$/.exec(width.trim());
  if (vwMatch) {
    return parseFloat(vwMatch[1]) >= DIALOG_MD_MIN_WIDTH_VW;
  }
  const pxMatch = /^([\d.]+)px$/.exec(width.trim());
  if (pxMatch) {
    return (parseFloat(pxMatch[1]) / window.innerWidth) * 100 >= DIALOG_MD_MIN_WIDTH_VW;
  }
  return false;
}

export const SMALL_DIALOG_SIZE = {
  mob_sm: {
    width: '70vw',
    minHeight: '15vh',
    maxHeight: '50vh',
  },
  mob_md: {
    width: '70vw',
    minHeight: '30vh',
    maxHeight: '65vh',
  },
};
